import { render, staticRenderFns } from "./EntityLevelAuditLogs.vue?vue&type=template&id=6ba93b0d&scoped=true"
import script from "./EntityLevelAuditLogs.vue?vue&type=script&lang=js"
export * from "./EntityLevelAuditLogs.vue?vue&type=script&lang=js"
import style0 from "./EntityLevelAuditLogs.vue?vue&type=style&index=0&id=6ba93b0d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba93b0d",
  null
  
)

export default component.exports